module.exports = require("fs-extra");


//////////////////
// WEBPACK FOOTER
// external "fs-extra"
// module id = 162
// module chunks = 0